import React, { useMemo } from 'react'
import type { TeamMemberT } from 'components/ShiftsList/components/ShiftCard/TeamsSection/types'
import useFavurTranslation from 'hooks/useFavurTranslation'
import IconAndTextBlock from 'redesign/components/molecules/IconAndTextBlock'
import type { PersonT } from 'types'
import { getFullAvatarUrl } from 'utils/avatar'
import { getAvatarNameFromPerson } from 'utils/person'
import AvatarGroup from '../AvatarGroup'
import { MAX_AVATARS } from './constants'
import { ColumnContainer } from './styles'
import type { ConflictListProps } from './types'

const ConflictList = ({ label, count = 0, persons = [], showAvatars = false, icon }: ConflictListProps) => {
  const { t } = useFavurTranslation()

  const avatars = useMemo(
    () =>
      persons.map((person) => ({
        avatarName: getAvatarNameFromPerson(person as PersonT),
        avatarUrl: person?.user?.avatarUrl ? getFullAvatarUrl(person?.user?.avatarUrl) : undefined,
        personId: person?.id,
      })),
    [persons],
  )

  if (!count) return null

  return (
    <ColumnContainer>
      {showAvatars && <AvatarGroup avatars={avatars as TeamMemberT[]} maxAvatars={MAX_AVATARS} />}

      <IconAndTextBlock icon={icon} variant="body2" title={t(label, { numConflicts: count })} />
    </ColumnContainer>
  )
}

export default ConflictList
